
import { Vue, Component, Prop } from "vue-property-decorator";
// import UiButton from "@/components/button/ui-button.vue";
import UiButtonTests from "@/components/button/ui-buttontests.vue";
import ProjectModal from "@/components/companyProjects/ProjectModal.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import { User } from "@/generated/graphql";

@Component({
  components: {
    // UiButton,
    UiButtonTests,
    ProjectModal,
    PlusIcon,
  },
})
export default class NewProjectsDashboard extends Vue {
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, default: undefined }) readonly size?: string;
  @Prop({ type: String, default: undefined }) readonly buttonText?: string;
  @Prop({ type: String, default: undefined }) readonly id?: string;
  dialog: boolean = false;

  toggle(): void {
    this.dialog = true;
  }

  get text(): string {
    if (!this.buttonText) {
      return "+ Create Client";

    }
    return this.buttonText;
  }

  get noCompany(): boolean {
    return !this.companyId;
  }
}
